/**
 * Generuje cache key dla useAsyncData z fallback na 'missing' jeśli ID jest undefined.
 *
 * @param prefix - Prefix klucza (np. 'maptica-products', 'maptica-workflow')
 * @param id - Opcjonalny ID (zwykle documentId.value)
 * @returns Cache key w formacie `${prefix}-${id ?? 'missing'}`
 *
 * @example
 * getCacheKey('maptica-products', documentId.value)
 * // => 'maptica-products-123' lub 'maptica-products-missing'
 */
export function getCacheKey(prefix: string, id?: string | number): string {
    return `${prefix}:${id ?? 'missing'}`
}
